export default "__VITE_ASSET__CXjjCQ_U__"